export default "__VITE_ASSET__Catz5cO3__"